import Icon from '@/components/ui/AppIcon';
import AppStoreButtons from '@/components/common/AppStoreButtons';

export default function CTASection() {
  return (
    <section className="py-20 px-4 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-r from-primary/10 to-secondary/10 dark:from-primary/20 dark:to-secondary/20 rounded-2xl p-8 lg:p-12 text-center border border-primary/20">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-success/10 dark:bg-success/20 rounded-full mb-6">
            <Icon name="SparklesIcon" size={20} className="text-success" />
            <span className="text-sm font-medium text-success">Start Your Journey Today</span>
          </div>
          
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
            Ready to Transform Your Trading?
          </h2>
          
          <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
            Join 50,000+ traders who trust Signaly&apos;s AI-driven signals. Start with our free plan and upgrade anytime.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <AppStoreButtons />

            <a
              href="/pricing"
              className="px-8 py-4 bg-card border border-border text-foreground font-heading font-semibold rounded-md hover:bg-muted transition-all duration-200 flex items-center space-x-2"
            >
              <Icon name="CurrencyDollarIcon" size={20} />
              <span>View Pricing Plans</span>
            </a>
          </div>
          
          <div className="mt-8 flex items-center justify-center space-x-6 text-sm text-muted-foreground">
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircleIcon" size={16} className="text-success" />
              <span>No credit card required</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircleIcon" size={16} className="text-success" />
              <span>Cancel anytime</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}